module.exports = __webpack_public_path__ + "img/magento-support-security_small@2x.200acc3c.webp";